import script from "./callServer.vue?vue&type=script&setup=true&lang=js"
export * from "./callServer.vue?vue&type=script&setup=true&lang=js"

import "./callServer.vue?vue&type=style&index=0&id=4bdd1226&scoped=true&lang=css"

import exportComponent from "/var/www/html/koboeat/test/customer_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bdd1226"]])

export default __exports__